import React, {FunctionComponent} from 'react';
import PropTypes from 'prop-types';
import {Field, Form} from 'react-final-form';
import CardActions from '@material-ui/core/CardActions';
import {TextField, Button} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import {makeStyles, Theme} from '@material-ui/core/styles';
import {useTranslate, useLogin, useNotify, useSafeSetState} from 'ra-core';

interface Props {
   redirectTo?: string;
}

interface FormData {
   email: string;
   password: string;
}

const useStyles = makeStyles(
   (theme: Theme) => ({
      form: {
         display: 'flex',
         flexDirection: 'column'
      },
      formContainer: {
         padding: '0 1em 1em 1em'
      },
      input: {
         marginTop: '1em'
      },
      button: {
         width: '100%'
      },
      icon: {
         marginRight: theme.spacing(1)
      },

      formFooter: {
         display: 'flex',
         justifyContent: 'flex-end',
         padding: '1em 1em 1em'
      }
   }),
   {name: 'RaLoginForm'}
);

const Input = ({
   meta: {touched, error}, // eslint-disable-line react/prop-types
   input: inputProps, // eslint-disable-line react/prop-types
   ...props
}) => <TextField error={!!(touched && error)} helperText={touched && error} {...inputProps} {...props} fullWidth />;

type Errors = {
   email: undefined | string;
   password: undefined | string;
};

const LoginForm: FunctionComponent<Props> = (props) => {
   const {redirectTo} = props;
   const [loading, setLoading] = useSafeSetState<boolean>(false);
   const login = useLogin();
   const translate = useTranslate();
   const notify = useNotify();
   const classes = useStyles(props);

   const validate = (values: FormData) => {
      const errors = {
         email: undefined,
         password: undefined
      } as Errors;

      if (!values.email) {
         errors.email = translate('ra.validation.required')!;
      }
      if (!values.password) {
         errors.password = translate('ra.validation.required')!;
      }
      return errors;
   };

   const submit = (values) => {
      setLoading(true);
      login(values, redirectTo)
         .then(() => {
            setLoading(false);
         })
         .catch((error) => {
            setLoading(false);
            notify(typeof error === 'string' ? error : typeof error === 'undefined' || !error.message ? 'ra.auth.sign_in_error' : error.message, 'warning');
         });
   };

   return (
      <Form
         onSubmit={submit}
         validate={validate}
         render={({handleSubmit}) => (
            <form className={classes.form} onSubmit={handleSubmit} noValidate>
               <div className={classes.formContainer}>
                  <div className={classes.input}>
                     <Field id="email" name="email" component={Input} variant="outlined" label={'Email'} disabled={loading} />
                  </div>
                  <div className={classes.input}>
                     <Field
                        id="password"
                        name="password"
                        variant="outlined"
                        component={Input}
                        label={'Password'}
                        type="password"
                        disabled={loading}
                        autoComplete="current-password"
                     />
                  </div>
               </div>
               <CardActions>
                  <Button variant="contained" type="submit" color="primary" disabled={loading} className={classes.button}>
                     {loading && <CircularProgress className={classes.icon} size={18} thickness={2} />}
                     {translate('ra.auth.sign_in')}
                  </Button>
               </CardActions>

               {/* <div className={classes.formFooter}>
            <Link to={{ pathname: "/register" }}>Registration</Link>
          </div> */}
            </form>
         )}
      />
   );
};

LoginForm.propTypes = {
   redirectTo: PropTypes.string
};

export default LoginForm;
